import React, { useEffect, useState } from "react";
import Pagination from '@mui/material/Pagination';
import { Box, Stack, Typography } from "@mui/material";

import ExerciseCard from "./ExerciseCard";

import { exerciseOptions, fetchData } from '../utils/fetchData'

const Exercises = ({ exercises, setExercises, bodyPart }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const [exercisesPerPage] = useState(9);

  // console.log(exercises);
  // console.log(exercises.length);

  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;
  const currentExercises = exercises.slice(indexOfFirstExercise, indexOfLastExercise);

  const paginate = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top of the exercises section
  };

  useEffect(() => {
    const fetchExercisesData = async () => {
      let exercisesData = []
      if (bodyPart === 'all') {
        exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);
      } else {
        exercisesData = await fetchData(`https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`, exerciseOptions);
      }
      setExercises(exercisesData); // Set the state with the fetched data
    }

    fetchExercisesData();

  }, [bodyPart, setExercises]); // Include setExercises in the dependency array

  return (
    <Box id="exercises" // Remove unnecessary #
      sx={{
        mt: { lg: '110px' }
      }}
      mt="50px"
      p="20px"
    >
      <Typography variant="h3" md="46px">Showing Results</Typography>
      <Stack direction="row" sx={{
        gap: { lg: '30px', xs: '50px' },
        textTransform: 'capitalize',
        margin: '30px 20px',
        alignItems: 'center'
      }}
      flexWrap="wrap" justifyContent="center">
        {currentExercises.map((exercise, index) => (
          <ExerciseCard key={index} exercise={exercise} />
        ))}
      </Stack>
      <Stack mt="100px" alignItems="right">
        {exercises.length > exercisesPerPage && (
          <Pagination 
            color="standard"
            defaultPage={1}
            count={Math.ceil(exercises.length / exercisesPerPage)}
            page={currentPage}
            onChange={paginate}
            size="large"
          />
        )}
      </Stack>
    </Box>
  )
}

export default Exercises;
